export const USER_START = 'USER_START';
export const USER_SUCCESS = 'USER_SUCCESS';
export const EDIT_USER = 'EDIT_USER';
export const USER_FAILURE = 'USER_FAILURE';
export const USER_RESET = 'USER_RESET';
export const GET_MENTOR = 'GET_MENTOR';
export const GET_MENTEES = 'GET_MENTEES';
export const GET_MENTEE = 'GET_MENTEE';
